// utils/userSession.ts
import Cookies from 'js-cookie';

export const getUserId = () => localStorage.getItem('userId');
export const getAuthToken = () => Cookies.get('accessToken');
